import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { CreateNewJobMutationVariables, CreateUserMutationVariables, EditProfileMutationVariables, SetFieldValuesMutationVariables } from 'graphql.generated';

import { ActionSource } from '../../../state/action-sources';

import { JobToolState } from '../../job-tool.reducer';

export const JobCreateActions = createActionGroup({
	source: ActionSource.JOB_CREATE,
	events: {
		'New Opportunity Button Clicked': emptyProps(),

		'State For Create Job Generated': props<{ retrievedState: JobToolState }>(),

		'Change Zone': emptyProps(),

		'Reset Zone Sensitive Inputs': emptyProps(),

		'Find Times Success': props<{
			result: any,
		}>(),
		'Find Times Error': props<{ error: Error }>(),

		'Select Time Slot': props<{
			timeSlot: number,
		}>(),

		'Save Job Form': emptyProps(),
		'Select Closed Reason': props<{ closedReason: string }>(),

		'Create And Close Job': emptyProps(),

		'Create Job': props<{
			createJobVariables: CreateNewJobMutationVariables,
			zoneId: string,
		}>(),
		'Create Job Success': props<{
			jobId: string,
			zoneId: string,
		}>(),
		'Create Job Error': props<{ error: Error }>(),

		'Create Customer': props<{ createCustomerVariables: CreateUserMutationVariables }>(),
		'Create Customer Success': props<{ customerId: string }>(),
		'Create Customer Error': props<{ error: Error }>(),

		'Update Customer': props<{ customerEditInput: EditProfileMutationVariables }>(),
		'Update Customer Success': emptyProps(),
		'Update Customer Error': props<{ error: Error }>(),

		'Set Fields': props<{ setFieldsVariables: SetFieldValuesMutationVariables }>(),
		'Set Fields Success': emptyProps(),
		'Set Fields Error': props<{ error: Error }>(),

		'Set Tags': emptyProps(),
		'Set Tags Success': emptyProps(),
		'Set Tags Error': props<{ error: Error }>(),

		'Create Required Event': emptyProps(),
		'Create Required Event Success': emptyProps(),
		'Create Required Event Error': props<{ error: Error }>(),
		'Job Origin Gained Focus': emptyProps(),
		'Add Stop Gained Focus': emptyProps(),
		'Add Room Gained Focus': emptyProps(),

		'Discard Opportunity Button Clicked': emptyProps(),
		'Discard Opportunity Shortcut Entered': props<{ discardOpportunityButtonAvailable: boolean }>(),
	},
});
